export default {"src":"/_next/static/media/0xae12c5930881c53715b369cec7606b70d8eb229f.60d126ad.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};